import DropdownBody from "@/components/shared/DropdownBody.vue";
import MarketplaceValue from '@/components/tableElements/MarketplaceValue.vue';
import { ref } from 'vue';
export default {
  name: 'ListMarketplaceValue',
  components: {
    DropdownBody,
    MarketplaceValue
  },
  props: {
    header: {
      type: String,
      default: 'SELECT COUNTRY'
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  expose: ['toggle', 'shown'],
  setup() {
    const shown = ref(false);
    return {
      shown
    };
  },
  methods: {
    toggle() {
      //console.log('list', this.list);
      const dropdown = this.$refs.dropdown;
      //console.log('dropdown', dropdown);
      if (!dropdown) return;
      dropdown.toggle();
    }
  }
};